// Soov registry data via the details.autospy.ee proxy. Fast (~600 ms) — this
// is the first source to land on the details screen.

import { detailsApiToken } from './http';
import { sanitizeRegistration } from './checkVehicle';
import { secureFetchJson } from '../security/secureFetch';

export interface CarDataDynamic {
  make?: string | null;
  model?: string | null;
  registreerimisaasta?: string | null;
  varv?: string | null; // color (Estonian)
  voimsus?: string | null; // power, e.g. "110 kW"
  kutuse_tuup?: string | null; // fuel type (Estonian)
  kaigukast?: string | null; // transmission (Estonian)
  keretuup?: string | null; // body type (Estonian)
}

export interface CarDataStaticField {
  title?: string | null;
  value?: string | null;
}

export type CarDataStatic = Record<string, CarDataStaticField | undefined>;

export interface CarDataResponse {
  dynamic?: CarDataDynamic | null;
  static?: CarDataStatic | null;
}

export async function fetchCarData(
  plate: string,
  options: { signal?: AbortSignal } = {},
): Promise<CarDataResponse> {
  return secureFetchJson<CarDataResponse>('/car-data', {
    query: { regnr: sanitizeRegistration(plate) },
    signal: options.signal,
    timeoutMs: 30_000,
    label: 'Car data',
    legacyToken: detailsApiToken(),
  });
}
